function validateVoucherPurchaseForm(form) {
    const errors = {};
  
    // Validate Voucher ID
    if (typeof form.voucherId !== "number" || isNaN(form.voucherId)) {
      errors.voucherId = "Please select voucher";
    }
  
    // Validate Purchaser Type
    if (typeof form.purchaserType !== "string" || form.purchaserType.trim() === "") {
      errors.purchaserType = "please select purchaser type";
    }
  
    // Validate Uttarakhand Bar ID
    if (typeof form.advocateBarId !== "string" || form.advocateBarId.trim() === "") {
      errors.advocateBarId = "Please enter the id of the purchaser";
    }
  
    // Validate Provided Serial Number
    // if (typeof form.providedSerialNo !== "string" || form.providedSerialNo.trim() === "") {
    //   errors.providedSerialNo = "Provided Serial Number is required and must be a non-empty string";
    // }
  
    // // Validate Quantity
    // if (typeof form.quantity !== "number" || isNaN(form.quantity) || form.quantity < 1) {
    //   errors.quantity = "Quantity  should be at least 1";
    // }
  
    return errors;
  }
  

  export default validateVoucherPurchaseForm;
  // Example usage:
//   const emptyVoucherPurchaseForm = {
//     voucherId: "",
//     purchaserType: "",
//     uttarakhandBarId: "",
//     providedSerialNo: "",
//     quantity: 1,
//   };
  
//   // Validate the emptyVoucherPurchaseForm
//   const validationErrors = validateVoucherPurchaseForm(emptyVoucherPurchaseForm);
  
//   // Check if there are any errors
//   if (Object.keys(validationErrors).length === 0) {
//     console.log("emptyVoucherPurchaseForm is valid!");
//   } else {
//     console.log("Validation errors:", validationErrors);
//   }
  